// Single source of truth for legal links and company data shown across the
// app. Long-form legal pages live in formular.so; this footer just links
// out.

const LEGAL_BASE = "https://formular.so";

export const LEGAL_LINKS = {
  terms: `${LEGAL_BASE}/terms`,
  privacy: `${LEGAL_BASE}/privacidad`,
  cookies: `${LEGAL_BASE}/cookies`,
  legalNotice: `${LEGAL_BASE}/aviso-legal`,
  contact: `${LEGAL_BASE}/contact`,
} as const;

const COMPANY = {
  brand: "Formular",
  email: "hello@formular.so",
} as const;

export function Footer({ variant = "full" }: { variant?: "full" | "minimal" }) {
  if (variant === "minimal") {
    return (
      <footer
        className="px-6 py-4 text-xs flex flex-wrap items-center justify-between gap-3"
        style={{ color: "#71717a" }}
      >
        <span>
          © {new Date().getFullYear()} {COMPANY.brand}.
        </span>
        <span className="flex gap-3">
          <a
            href={LEGAL_LINKS.terms}
            target="_blank"
            rel="noreferrer noopener"
            className="hover:underline"
          >
            Términos
          </a>
          <a
            href={LEGAL_LINKS.privacy}
            target="_blank"
            rel="noreferrer noopener"
            className="hover:underline"
          >
            Privacidad
          </a>
          <a
            href={LEGAL_LINKS.cookies}
            target="_blank"
            rel="noreferrer noopener"
            className="hover:underline"
          >
            Cookies
          </a>
        </span>
      </footer>
    );
  }

  return (
    <footer
      className="mt-16 px-6 py-10 border-t"
      style={{
        borderColor: "rgba(0,0,0,0.08)",
        color: "#71717a",
      }}
    >
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row gap-8 md:items-start md:justify-between text-sm">
        <div>
          <a
            href="/"
            className="block text-base font-bold"
            style={{ color: "#0f0f0f" }}
          >
            Formular
          </a>
          <p className="mt-0.5 text-[10px] font-medium tracking-wider uppercase" style={{ color: "#a1a1aa" }}>
            by Formular
          </p>
          <p className="mt-2 text-xs leading-relaxed">
            <a
              href={`mailto:${COMPANY.email}`}
              className="hover:underline"
            >
              {COMPANY.email}
            </a>
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-6 gap-y-2 text-xs">
          <a
            href={LEGAL_LINKS.legalNotice}
            target="_blank"
            rel="noreferrer noopener"
            className="hover:underline"
          >
            Aviso legal
          </a>
          <a
            href={LEGAL_LINKS.privacy}
            target="_blank"
            rel="noreferrer noopener"
            className="hover:underline"
          >
            Privacidad
          </a>
          <a
            href={LEGAL_LINKS.cookies}
            target="_blank"
            rel="noreferrer noopener"
            className="hover:underline"
          >
            Cookies
          </a>
          <a
            href={LEGAL_LINKS.terms}
            target="_blank"
            rel="noreferrer noopener"
            className="hover:underline"
          >
            Términos
          </a>
          <a
            href={LEGAL_LINKS.contact}
            target="_blank"
            rel="noreferrer noopener"
            className="hover:underline"
          >
            Contacto
          </a>
        </nav>
      </div>
    </footer>
  );
}
